/** @internal */
import site from './site';
import { getEasyRootDomain } from './utils';

const rootDomain = getEasyRootDomain();

/** @ignore */
export default {
  ...site,
  staging: {
    h5_login_redirect: 'redirect_uri',
    h5_authuser: 'authuser',
    h5_user_id: 'qingting_id',
    h5_refresh_token: 'refresh_token',
    h5_access_token: 'access_token',
    h5_cookie_domain: `.${rootDomain}`,
  },
  production: {
    h5_login_redirect: 'redirect_uri',
    h5_authuser: 'authuser',
    h5_user_id: 'qingting_id',
    h5_refresh_token: 'refresh_token',
    h5_access_token: 'access_token',
    h5_cookie_domain: `.${rootDomain}`,
  },
};
